import { OnboardingPhaseLocation } from "@forgepoint/shared";

/** Display labels for onboarding phase location values. */
export const PHASE_LOCATION_LABELS: Record<OnboardingPhaseLocation, string> = {
  REMOTE: "Remote",
  ONSITE: "On-site",
};
